import * as React from 'react';

import Download16 from './Download16';

export const download16 = () => <Download16 />;

export default {
    title: 'Icon|Line|Download16',
    component: Download16,
    parameters: {
        notes: "`import Download16 from 'box-ui-elements/es/icon/line/Download16';`",
    },
};
